import useCallApi from '../../utilities/axios'

export type CertificateRequest = {
    certificateYear?: number
    certificateType?: string
    userID: number | null
}

export type CertificateDetail = {
    projectID: number
    projectNumber: string
    closedDate: string
    receiveDate: string
    projectName: Translation
    projectType: {
        id: number
        name: Translation
    }
    name: Translation
    title: Translation
    titleID: number
    certificateNo: string
    certificateType: string
}

type Translation = {
    th: string
    en: string
}

export type deleteProjectCloseRequest = {
    projectIDs: number[]
}

export type CertificateSummaryRequest = {
    certificateYear?: number
    userID: number
}

export type CertificateSummary = {
    label: Translation
    value: number
}

export const useCertificateSummary = () => {
    const callApi = useCallApi()

    const getCertificates = async (values: CertificateRequest) => {
        const { data } = await callApi.axiosPost({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/dashboard/search/project/certificate`,
            params: { ...values },
        })

        return data
    }

    const getCertificateSummary = async (values: CertificateSummaryRequest) => {
        const query = new URLSearchParams()
        query.append('userID', String(values.userID))
        if (values.certificateYear) {
            query.append('certificateYear', String(values.certificateYear))
        }

        const { data } = await callApi.axiosGet<CertificateSummary[]>({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/dashboard/certificate/summary?${query.toString()}`,
        })

        return data
    }

    return {
        getCertificates,
        getCertificateSummary,
    }
}
